import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.conversation.ConversationHelper.';
  public static readonly now = `${Id.prefix}now`;
  public static readonly supportTypeAll = `${Id.prefix}supportTypeAll`;
  public static readonly supportTypeBasic = `${Id.prefix}supportTypeBasic`;
  public static readonly supportTypeQuoteReview = `${Id.prefix}supportTypeQuoteReview`;
  public static readonly supportTypeEngineeredToOrder = `${Id.prefix}supportTypeEngineeredToOrder`;
  public static readonly supportTypeQuoteAssistanceRequest = `${Id.prefix}supportTypeQuoteAssistanceRequest`;
  public static readonly supportStatusDraft = `${Id.prefix}supportStatusDraft`;
  public static readonly supportStatusActive = `${Id.prefix}supportStatusActive`;
  public static readonly supportStatusCancelled = `${Id.prefix}supportStatusCancelled`;
  public static readonly supportStatusNew = `${Id.prefix}supportStatusNew`;
  public static readonly supportStatusOverdue = `${Id.prefix}supportStatusOverdue`;
  public static readonly supportStatusAll = `${Id.prefix}supportStatusAll`;
  public static readonly supportStatusResolved = `${Id.prefix}supportStatusResolved`;
  public static readonly supportStatusReactivated = `${Id.prefix}supportStatusReactivated`;
}

export class LangConversationHelper {
  private constructor() {}
  public static now(): string {
    return interpolate(Id.now);
  }
  public static supportTypeAll(): string {
    return interpolate(Id.supportTypeAll);
  }
  public static supportTypeBasic(): string {
    return interpolate(Id.supportTypeBasic);
  }
  public static supportTypeQuoteReview(): string {
    return interpolate(Id.supportTypeQuoteReview);
  }
  public static supportTypeEngineeredToOrder(): string {
    return interpolate(Id.supportTypeEngineeredToOrder);
  }
  public static supportTypeQuoteAssistanceRequest(): string {
    return interpolate(Id.supportTypeQuoteAssistanceRequest);
  }
  public static supportStatusDraft(): string {
    return interpolate(Id.supportStatusDraft);
  }
  public static supportStatusActive(): string {
    return interpolate(Id.supportStatusActive);
  }
  public static supportStatusCancelled(): string {
    return interpolate(Id.supportStatusCancelled);
  }
  public static supportStatusNew(): string {
    return interpolate(Id.supportStatusNew);
  }
  public static supportStatusOverdue(): string {
    return interpolate(Id.supportStatusOverdue);
  }
  public static supportStatusAll(): string {
    return interpolate(Id.supportStatusAll);
  }
  public static supportStatusResolved(): string {
    return interpolate(Id.supportStatusResolved);
  }
  public static supportStatusReactivated(): string {
    return interpolate(Id.supportStatusReactivated);
  }
}

export class ConversationHelperModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.now, 'now', 'Label for current time');
    register.add(Id.supportTypeAll, 'All', 'Support type: All');
    register.add(Id.supportTypeBasic, 'Basic', 'Support type: Basic');
    register.add(Id.supportTypeQuoteReview, "{{glossary 'quote'}} Review", 'Support type: Quote Review');
    register.add(Id.supportTypeEngineeredToOrder, "{{glossary 'special-item'}}", 'Support type: Engineered To Order');
    register.add(
      Id.supportTypeQuoteAssistanceRequest,
      "{{glossary 'support-request'}}",
      'Support type: Quote Assistance Request'
    );
    register.add(Id.supportStatusDraft, 'Draft', 'Support status: Draft');
    register.add(Id.supportStatusActive, 'Active', 'Support status: Active');
    register.add(Id.supportStatusCancelled, 'Cancelled', 'Support status: Cancelled');
    register.add(Id.supportStatusNew, 'New', 'Support status: New');
    register.add(Id.supportStatusOverdue, 'Overdue', 'Support status: Overdue');
    register.add(Id.supportStatusAll, 'All', 'Support status: All');
    register.add(Id.supportStatusResolved, 'Resolved', 'Support status: Resolved');
    register.add(Id.supportStatusReactivated, 'Reactivated', 'Support status: Reactivated');
  }
}
